import { useContext } from 'react'
import { context } from '../components/LanguageProvider'

export const useLanguage = () => useContext(context)
